module.exports = __webpack_public_path__ + "img/i-os.1012f708.svg";